import React from "react";
import { CardUi } from "../../../ui/CardUi";
import { AccesoPerfilTree } from "./AccesoPerfilTree";

export const AccesoPerfilDiv = ({ keysChecked, onCheck }) => {
  return (
    <>
      <CardUi title="Accesos" size="small" type="inner">
        <AccesoPerfilTree keysChecked={keysChecked} onCheck={onCheck} />
      </CardUi>
    </>
  );
};
